export default __webpack_public_path__ + "static/media/polk_g_ssrank.49685af2.png";